import React from 'react'
import type { TxnBadge as TnxBadgeType } from '@src/types/graphql-types'
import { makeStyles } from 'tss-react/mui'
import { Tooltip, TooltipProps, Typography } from '@mui/material'
import LabelChip from '@src/components/LabelChip'

const useStyles = makeStyles()((theme) => ({
  promoChip: {
    '& .MuiChip-root': {
      backgroundColor: theme.palette.promoGreen,
      height: '26px',
    },
  },
  clickableChip: {
    '& .MuiChip-root': {
      cursor: 'pointer',
    },
  },
  promoChipLabel: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    width: theme.typography.pxToRem(320),
    fontSize: theme.typography.pxToRem(16),
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.16)',
    padding: theme.spacing(2, 4, 4),
    top: '10px',
    [theme.breakpoints.down('md')]: {
      top: '0',
      right: '10px',
    },
    [theme.breakpoints.down('sm')]: {
      top: '0',
      right: '20px',
      width: '10rem',
    },
  },
  tooltipWrapper: {
    display: 'inline-block',
  },
  arrow: {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(15),
    '&::before': {
      boxShadow: '0px 0px 2px rgba(0,0,0,0.2)',
    },
  },
  promoTitle: { fontSize: theme.typography.pxToRem(14) },
}))

const PROMO_MESSAGE = 'Up to 15% Off'
const PROMO_TOOLTIP_MESSAGE =
  'Save 15% off certain sizes to celebrate 50 years of the Sigma-Aldrich® brand. Offer ends December 26.'

interface TxnBadgeProps {
  txnBadge?: TnxBadgeType
  showTooltip?: boolean
  toolTipPlacement?: TooltipProps['placement']
}

const TxnBadge: React.FC<TxnBadgeProps> = ({
  showTooltip = false,
  toolTipPlacement = 'top',
}) => {
  const { classes, cx } = useStyles()

  const tooltipContent = (
    <Typography className={classes.promoTitle}>
      {PROMO_TOOLTIP_MESSAGE}
    </Typography>
  )

  const labelChip = (
    <LabelChip
      label={
        <Typography className={classes.promoChipLabel}>
          {PROMO_MESSAGE}
        </Typography>
      }
      className={cx(classes.promoChip, {
        [classes.clickableChip]: showTooltip,
      })}
    />
  )

  return (
    <>
      {showTooltip ? (
        <Tooltip
          arrow
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
          }}
          placement={toolTipPlacement}
          title={tooltipContent}
          enterTouchDelay={0}
        >
          <div className={classes.tooltipWrapper}>{labelChip}</div>
        </Tooltip>
      ) : (
        labelChip
      )}
    </>
  )
}

export default TxnBadge
